import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterLink, ButtonDirective],
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit, OnDestroy {
  errorMessage = '';
  error403 = false;
  error404 = false;
  errorJson: any = null;

  private routeDataSubscription: Subscription | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    try {
      const errorParam = this.route.snapshot.queryParamMap.get('error');
      if (errorParam) {
        this.errorJson = JSON.parse(errorParam);
      }
    } catch {
      this.errorJson = this.route.snapshot.queryParamMap.get('error');
    }

    this.routeDataSubscription = this.route.data.subscribe(routeData => {
      if (routeData['error403']) {
        this.error403 = routeData['error403'];
      }
      if (routeData['error404']) {
        this.error404 = routeData['error404'];
      }
      if (routeData['errorMessage']) {
        this.errorMessage = routeData['errorMessage'];
      }
    });
  }

  ngOnDestroy(): void {
    this.routeDataSubscription?.unsubscribe();
  }

  goToPreviousPage(): void {
    history.back();
  }
}
